import { render, staticRenderFns } from "./App.vue.html?vue&type=template&id=3fb5e523&scoped=true&external"
import script from "./App.vue.js?vue&type=script&lang=js&external"
export * from "./App.vue.js?vue&type=script&lang=js&external"
import style0 from "./App.vue.scss?vue&type=style&index=0&id=3fb5e523&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb5e523",
  null
  
)

export default component.exports